/** Lokalne zapisy (token, draft outfit/layout offline). */

const TOKEN_KEY = 'pieskowo.token';
const ACCOUNT_KEY = 'pieskowo.accountId';
const PROFILE_KEY = 'pieskowo.profileId';

export const SaveLocal = {
  getToken(): string | null {
    try {
      return localStorage.getItem(TOKEN_KEY);
    } catch {
      return null;
    }
  },
  setToken(token: string): void {
    localStorage.setItem(TOKEN_KEY, token);
  },
  clearAuth(): void {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(ACCOUNT_KEY);
    localStorage.removeItem(PROFILE_KEY);
  },
  /**
   * Pełny reset lokalny (po usunięciu konta / GDPR):
   * auth + drafty pieska, stroje, park session, onboarding.
   * Nie rusza preferencji lektora/audio (ustawienia urządzenia).
   */
  clearPlayerData(): void {
    this.clearAuth();
    const keep = new Set(['pieskowo.lektor', 'pieskowo.audio']);
    try {
      const keys: string[] = [];
      for (let i = 0; i < localStorage.length; i++) {
        const k = localStorage.key(i);
        if (k && k.startsWith('pieskowo.') && !keep.has(k)) keys.push(k);
      }
      for (const k of keys) localStorage.removeItem(k);
    } catch {
      /* private mode */
    }
  },
  getAccountId(): string | null {
    return localStorage.getItem(ACCOUNT_KEY);
  },
  setAccountId(id: string): void {
    localStorage.setItem(ACCOUNT_KEY, id);
  },
  getProfileId(): string | null {
    return localStorage.getItem(PROFILE_KEY);
  },
  setProfileId(id: string): void {
    localStorage.setItem(PROFILE_KEY, id);
  },
  getJson<T>(key: string, fallback: T): T {
    try {
      const raw = localStorage.getItem(key);
      if (!raw) return fallback;
      return JSON.parse(raw) as T;
    } catch {
      return fallback;
    }
  },
  setJson(key: string, value: unknown): void {
    localStorage.setItem(key, JSON.stringify(value));
  },
};
